import { jsxs as o, jsx as t } from "react/jsx-runtime";
import { isMobileDevice as m } from "../../utils/userAgent.es.js";
import { chakra as r } from "@chakra-ui/react";
import { n as d, o as f } from "../../floating-ui.react-5e63cf1f.js";
import { useDatePickerContext as p, useDatePickerStyle as D } from "./DatePicker.context.es.js";
import { DatePickerControl as k } from "./components/DatePickerControl.es.js";
import { DatePickerDays as P } from "./components/DatePickerDays.es.js";
import { DatePickerHeader as g } from "./components/DatePickerHeader.es.js";
import { DatePickerWeekDays as u } from "./components/DatePickerWeekDays.es.js";
const M = () => {
  const { getFloatingProps: i, dataTestId: s, floatingContext: a, floatingStyles: n, isOpen: c, refs: l } = p(), e = D();
  return /* @__PURE__ */ o(r.div, { __css: e.root, "data-testid": s, children: [
    /* @__PURE__ */ t(k, {}),
    !m() && /* @__PURE__ */ t(d, { children: c && /* @__PURE__ */ t(f, { context: a, initialFocus: -1, visuallyHiddenDismiss: !0, children: /* @__PURE__ */ o(
      r.div,
      {
        __css: e.calendar,
        ...i({
          ref: l.setFloating,
          style: n
        }),
        children: [
          /* @__PURE__ */ t(g, {}),
          /* @__PURE__ */ t(u, {}),
          /* @__PURE__ */ t(P, {})
        ]
      }
    ) }) })
  ] });
};
export {
  M as DatePickerComponent
};
//# sourceMappingURL=DatePicker.component.es.js.map
